import { Field, InputType } from 'type-graphql'

@InputType()
export class BasicAuthLoginArgs {
  @Field(() => String)
  recaptchaToken: string

  @Field(() => String)
  username: string

  @Field(() => String)
  password: string
}
